import { useCallback, useSyncExternalStore } from "react";
import { getMotionPreferenceController, type MotionPreference } from "./motionPreference";

const SERVER_PREFERENCE: MotionPreference = "system";

export interface MotionPreferenceState {
    readonly preference: MotionPreference;
    readonly setPreference: (preference: MotionPreference) => void;
}

export function useMotionPreference(): MotionPreferenceState {
    const controller = getMotionPreferenceController();

    const preference = useSyncExternalStore(
        controller.subscribe,
        controller.getSnapshot,
        () => SERVER_PREFERENCE,
    );

    const setPreference = useCallback(
        (next: MotionPreference) => {
            controller.setPreference(next);
        },
        [controller],
    );

    return { preference, setPreference };
}
